import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid2';
import { Typography, Stack } from '@mui/material';
import PropTypes from 'prop-types';
import { ConfirmModal } from 'shared/modals/confirmModal';
import {
  QuotaProptypes,
  ClientFormPropTypes,
} from 'shared/propTypes/quotaType';
import logger from 'utils/logger';

const confirmWindowProps = {
  quotaSrcOrg: PropTypes.shape(QuotaProptypes),
  formState: PropTypes.shape(ClientFormPropTypes).isRequired,
  showConfirmBeforeSend: PropTypes.bool,
  handleClick: PropTypes.func,
};

const log = logger.createLogger('ConfirmClientSettingsModal');

export const ConfirmClientSettingsModal = ({
  quotaSrcOrg,
  formState,
  showConfirmBeforeSend,
  handleClick,
}) => {
  const wasChanged = (formerValue, currentValue) => {
    if (formerValue === null && currentValue !== null) {
      return true;
    }
    return !(formerValue.toString() === currentValue.toString());
  };

  const generateConfirmWindowContents = () => {
    // Check if there are any changes
    const hasQuotaChange = wasChanged(quotaSrcOrg.quota, formState.quota);
    const hasDateChange = wasChanged(
      quotaSrcOrg.monthlyInvoiceDate,
      formState.monthlyInvoiceDate
    );
    // Original code for showing changes
    return (
      <Stack spacing={3}>
        {hasQuotaChange && (
          <Grid container>
            <Grid size={6}>
              <Typography variant="body1">
                {intl.get(
                  'organization_settings_client_management_label_quota'
                )}
              </Typography>
            </Grid>
            <Grid>
              <Typography variant="body1">
                {quotaSrcOrg.quota} → {formState.quota}
              </Typography>
            </Grid>
          </Grid>
        )}
        {hasDateChange && (
          <Grid container>
            <Grid size={6}>
              <Typography variant="body1">
                {intl.get(
                  'organization_settings_client_management_label_billing_date'
                )}
              </Typography>
            </Grid>
            <Grid>
              <Typography variant="body1">
                {quotaSrcOrg.monthlyInvoiceDate} →{' '}
                {formState.monthlyInvoiceDate}
              </Typography>
            </Grid>
          </Grid>
        )}
      </Stack>
    );
  };

  return (
    <ConfirmModal
      isOpened={showConfirmBeforeSend}
      onCancel={() => handleClick(false)}
      onConfirm={() => handleClick(false, true)}
      title={intl.get(
        'organization_settings_client_settings_modal_text_confirm_title'
      )}
      bodyText={intl.get(
        'organization_settings_client_settings_modal_text_confirm_hint'
      )}
      confirmButtonText={intl.get(
        'organization_settings_client_settings_modal_button_submit'
      )}
      cancelButtonText={intl.get(
        'organization_settings_client_settings_modal_button_cancel'
      )}
      cancelButtonColor="secondary">
      <div style={{ width: '700px' }}>
        {showConfirmBeforeSend && generateConfirmWindowContents()}
      </div>
    </ConfirmModal>
  );
};

ConfirmClientSettingsModal.propTypes = confirmWindowProps;
